import parse from 'date-fns/parse';

import {_, ngettext, pgettext} from './i18n';

/* gettext couldn't be used dynamically, so all the used strings has to be defined static once */
ngettext('%(count)s day remaining', '%(count)s days remaining', 0);
ngettext('%(count)s hour remaining', '%(count)s hours remaining', 0);
ngettext('%(count)s minute remaining', '%(count)s minutes remaining', 0);
ngettext('%(count)s second remaining', '%(count)s seconds remaining', 0);

export const MONTHS = [
    _('January'),
    _('February'),
    _('March'),
    _('April'),
    _('May'),
    _('June'),
    _('July'),
    _('August'),
    _('September'),
    _('October'),
    _('November'),
    _('December'),
];

export const MONTHS_SHORT = [
    pgettext('January (abbreviation)', 'Jan'),
    pgettext('February (abbreviation)', 'Feb'),
    pgettext('March (abbreviation)', 'Mar'),
    pgettext('April (abbreviation)', 'Apr'),
    pgettext('May (abbreviation)', 'May'),
    pgettext('June (abbreviation)', 'Jun'),
    pgettext('July (abbreviation)', 'Jul'),
    pgettext('August (abbreviation)', 'Aug'),
    pgettext('September (abbreviation)', 'Sep'),
    pgettext('October (abbreviation)', 'Oct'),
    pgettext('November (abbreviation)', 'Nov'),
    pgettext('December (abbreviation)', 'Dec'),
];

export const WEEKDAYS_LONG = [
    _('Sunday'),
    _('Monday'),
    _('Tuesday'),
    _('Wednesday'),
    _('Thursday'),
    _('Friday'),
    _('Saturday'),
];

export const WEEKDAYS_SHORT = [
    pgettext('Sunday (abbreviation)', 'Sun'),
    pgettext('Monday (abbreviation)', 'Mon'),
    pgettext('Tuesday (abbreviation)', 'Tue'),
    pgettext('Wednesday (abbreviation)', 'Wed'),
    pgettext('Thursday (abbreviation)', 'Thu'),
    pgettext('Friday (abbreviation)', 'Fri'),
    pgettext('Saturday (abbreviation)', 'Sat'),
];

const TimeChunks = [
    {singular: 'day', plural: 'days', limit: 60 * 60 * 24},
    {singular: 'hour', plural: 'hours', limit: 60 * 60},
    {singular: 'minute', plural: 'minutes', limit: 60},
    {singular: 'second', plural: 'seconds', limit: 1},
];

const getTimeChunk = seconds => {
    const length = TimeChunks.length;

    for (let index = 0, chunk; index < length; index++) {
        chunk = TimeChunks[index];

        if (seconds > chunk.limit) return chunk;
    }

    return TimeChunks[length - 1];
};

export const getRemainingLabel = milliseconds => {
    const seconds = milliseconds / 1000;
    const {singular, plural, limit} = getTimeChunk(seconds);
    const count = Math.floor(seconds / limit);
    const label = ngettext(
        `%(count)s ${singular} remaining`,
        `%(count)s ${plural} remaining`,
        count,
    );

    return label.interpolate({count});
};

export const minutesSinceMidnight = date => {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    return (hours * 60) + minutes;
};

export const getDateTime = (date, time) => parse(`${date} ${time}`);



// WEBPACK FOOTER //
// ./scripts/utils/time.js